// extracted by mini-css-extract-plugin
export default {"rowTitle":"rowTitle-FcEe8","titleContainer":"titleContainer-p1il8","editPin":"editPin-FGX_8","description":"description-pfJ0t"};